import * as Fetch from '@/helpers/fetch'

interface CoinHistoryParam {
  offset?: number
  limit?: number
  fromDate: any 
  toDate: any
}

export const triggerHealthCheck = async (state?: string): Promise<Fetch.HttpResponse> => {
  let url = `${process.env.VUE_APP_SERVICE_URL}/v1/actuator/health`
  const urlSearchParams = new URLSearchParams(window.location.search)
  const { event_code: eventCode } = Object.fromEntries(urlSearchParams.entries())
  if (eventCode) {
    url = `${url}?event_code=${eventCode}`
  }
  if (state) {
    url = `${url}&state=${state}`
  }
  try {
    const result = await Fetch.get(url)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const getCustomerInfo = async (
  token: string,
  params?: string[],
  trackEventCode?: boolean
): Promise<Fetch.HttpResponse> => {
  let url = `${process.env.VUE_APP_SERVICE_URL}/v1/me`
  if (params && params.length > 0) {
    const value = params.join(',')
    url = `${url}?fields=${value}`
  } else if (trackEventCode) {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const { event_code: eventCode } = Object.fromEntries(urlSearchParams.entries())
    if (eventCode) {
      url = `${url}?event_code=${eventCode}`
    }
  }

  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
export const getCustomerInfoWithExternalTokenFields = async (
  token: string,
  params?: string[],
  trackEventCode?: boolean
): Promise<Fetch.HttpResponse> => {
  let url = `${process.env.VUE_APP_SERVICE_URL}/v1/me`
  if (params && params.length > 0) {
    const value = params.join(',')
    url = `${url}?fields=${value}&external_token_fields=externalId`
  } else if (trackEventCode) {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const { event_code: eventCode } = Object.fromEntries(urlSearchParams.entries())
    if (eventCode) {
      url = `${url}?event_code=${eventCode}`
    }
  }

  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const getCoinHistory = async (
  token: string,
  params?: CoinHistoryParam
): Promise<Fetch.HttpResponse> => {
  let url = `${process.env.VUE_APP_SERVICE_URL}/v1/me/point-history`

  if (params) {
    url = `${url}?fromDate=${params.fromDate}&toDate=${params.toDate}&limit=${params.limit}&offset=${params.offset}`
  }
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const unlinkLineAccount = async (
  token: string,
  reasonList: any
): Promise<Fetch.HttpResponse | undefined> => {
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/me/line-account`
  const requestBody = {
    reasons: reasonList,
  }
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  }
  try {
    const result = await Fetch.del(url, options)

    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const getUnlinkReasons = async (token: string): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/unlink-reasons`
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const updateCustomerProfiles = async (
  token: string,
  requestBody: any
): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/me`
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  }
  try {
    const result = await Fetch.patch(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const getToken = async (token: string): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/me?fields=token`
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const getBZBToken = async (token: string, socialToken: string): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/me?fields=bzb_token&social_token=${socialToken}`
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  }
  try {
    const result = await Fetch.get(url, options)

    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const getQuotaUpdateMobileNumber = async (
  token: string,
  param?: string
): Promise<Fetch.HttpResponse> => {
  const featureName = param ? `?feature=${param}` : ''
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/me/quota${featureName}`
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const updateMobileNumber = async (
  token: string,
  requestBody: any
): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/me/mobile-number`
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  }
  try {
    const result = await Fetch.patch(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
